import { INavListItem } from '@/api/types/public';
import { useJump } from '@/components/MagicJump';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { useStore } from '@/providers/app-store-provider';
import { ProviderType } from '@/reporting';

import { setSession } from '@/utils/tools';
import { CollapseArrowUpOutlined } from '@zeelool/icon';
import { useEffect, useState } from 'react';
import ImageNav from './ImageNav';
import LensProcessNav from './LensProcessNav';
import TextNav from './TextNav';

// 一级导航项组件
const MobileMenuItem = ({
  item,
  firstLevelIndex,
  firstLevelTitle,
}: {
  item: INavListItem; // 菜单数据
  firstLevelIndex: number; // 所属的一级菜单索引
  firstLevelTitle: string; // 一级菜单标题
}) => {
  const [openCollapse, setOpenCollapse] = useState(false);
  const { trackEvent } = useReporting();
  const setIsOpenSideNav = useStore((state) => state.setIsOpenSideNav);
  const { cnName } = useRouteMetadata();
  const toJumpTarget = useJump();

  // 计算属性
  const isJumpLevel = !!item.content?.Jump_target;
  const hasChildren = !!item.children?.length;

  // 获取箭头旋转类名
  const getArrowRotationClass = () => {
    if (!hasChildren) {
      return 'rotate-[90deg]';
    }
    if (openCollapse) {
      return 'rotate-[0deg]';
    }
    return 'rotate-180';
  };

  // 初始化时检查是否有图片导航项，如果有则默认展开
  useEffect(() => {
    if (item.children) {
      const hasImageNav = item.children.some((cItem) => cItem?.template_id === 3);
      if (hasImageNav) {
        setOpenCollapse(true);
      }
    }
  }, [item.children]);

  // 处理导航点击
  const handleNavClick = (title: string, index: number) => {
    trackEvent(
      {
        eventName: 'SideNavBarTab_Click',
        properties: {
          page_name: cnName,
          url_path: window.location.href,
          tab_name: title,
          tab_index: index,
        },
      },
      [ProviderType.SENSORS],
    );

    if (hasChildren) {
      setOpenCollapse(!openCollapse);
    }

    if (isJumpLevel) {
      setIsOpenSideNav(false);
      if (item.content.jump_type === 1) {
        setSession('zl_goodsListEnterPageScene', '全局导航');
      }
      toJumpTarget({ Jump_target: item.content.Jump_target, jump_type: item.content.jump_type });
    }
  };

  if (!item.content) return null;

  return (
    <div>
      <div>
        <div
          className={`flex justify-between items-center h-[45px] bg-white px-[14px] font-bb cursor-pointer ${
            openCollapse ? '!bg-[#eeeeee]' : ''
          }`}
          onClick={() => handleNavClick(item.content.nav_name, firstLevelIndex)}
        >
          <span className="text-[14px]">{item.content.nav_name}</span>
          <CollapseArrowUpOutlined
            className={`text-[12px] transition-all duration-300 ${getArrowRotationClass()}`}
          />
        </div>
      </div>

      {hasChildren && (
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            openCollapse ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div>
            {item.children?.map((cItem, secondLevelIndex) => {
              if (cItem.template_id === 2) {
                return (
                  <TextNav
                    key={cItem.id}
                    item={cItem}
                    firstLevelIndex={firstLevelIndex}
                    firstLevelTitle={firstLevelTitle}
                    secondLevelIndex={secondLevelIndex}
                    isLast={secondLevelIndex === item.children.length - 1}
                  />
                );
              }

              if (cItem.template_id === 3) {
                return (
                  <ImageNav
                    key={cItem.id}
                    item={cItem}
                    firstLevelIndex={firstLevelIndex}
                    firstLevelTitle={firstLevelTitle}
                    // secondLevelIndex={secondLevelIndex}
                  />
                );
              }

              if (cItem.template_id === 4) {
                return <LensProcessNav key={cItem.id} />;
              }

              return null;
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileMenuItem;
